export class nullString {
	String : string
	Valid  : boolean
}